/* unplugin-vue-components disabled */import { render } from "./KilaKilaArchiveCard.vue?vue&type=template&id=2a6a1a50&scoped=true"
import script from "./KilaKilaArchiveCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaArchiveCard.vue?vue&type=script&lang=js"

import "./KilaKilaArchiveCard.vue?vue&type=style&index=0&id=2a6a1a50&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6a1a50"]])

export default __exports__